import { CroppingPatternReportModel } from "@agroyaar/sdk";
import ColumnChart from "@/shared/components/charts/ColumnChart";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import {
  makeChartHumidityRiskTitle,
  mapRiskToChartData,
} from "@/features/reports/presentation/components/cropping-pattern/utils/temperature-risk-charts";

interface HumidityRisksProps {
  croppingPatternReports: CroppingPatternReportModel[];
  pageNumber: number;
}

const HumidityRisks = ({
  croppingPatternReports,
  pageNumber,
}: HumidityRisksProps) => {
  return (
    <ReportTemplate serviceType="CROPPING_PATTERN" pageNumber={pageNumber}>
      <div className="w-full flex flex-col justify-between">
        <div className="w-full flex flex-col justify-center items-start my-3">
          <Title>ریسک‌های رطوبتی</Title>
          <div className=" w-full flex flex-col justify-center items-center">
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-y-3 my-2">
              {croppingPatternReports.map(({ crop, humidityRisks }) =>
                humidityRisks.map((risk, i) => (
                  <ColumnChart
                    key={i}
                    data={mapRiskToChartData(risk)}
                    height={290}
                    title={makeChartHumidityRiskTitle(risk, crop.persianName)}
                    titleFontSize="12px"
                    labelsFontSize="10px"
                    color={risk.type === "ABOVE" ? "red" : "blue"}
                    yAxisTitle="درصد احتمال"
                    decimalNumber={0}
                  />
                ))
              )}
            </div>

            <div className=" w-full flex flex-col justify-center items-center">
              <Title>
                درصد احتمال وقوع رطوبت محیط بالا در هر ماه برای هر محصول
              </Title>
              <p className="text-[16px] !font-[B-Nazanin]">
                بر اساس اطلاعات هواشناسی 30 سال گذشته
              </p>
            </div>
          </div>
        </div>

        <NoteBox>
          براساس گزارش‌های علمی، درصد رطوبت هوای بالاتر از مقدار تعریف شده در
          نمودارهای بالا می‌تواند باعث ایجاد مشکلاتی برای محصولات شود.
        </NoteBox>
      </div>
    </ReportTemplate>
  );
};

export default HumidityRisks;
